<template>
   <footer class="iq-footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 text-left">
                Version {{ version }}
            </div>
            <div class="col-lg-6 text-right">
                Copyright {{year}} <a href="https://www.nextspin.com">{{ appName }}</a> All Rights Reserved.
            </div>
        </div>
    </div>
</footer>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name:"Footer",
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    prop:{
    },
    computed : {
        ...mapGetters({
            appName: 'appName',
            version: 'version'
        })
    }
}
</script>